import "./lineTitle.css";
const LineTitle = ({children,title}) => {
  return (
    <div className="a-line-general-container flex w-100">
      <div className="flex ">
        <label className="font1 "> {title}</label>
      </div>
      <div className=" flex1 flex ">
        <div className="a-line-title margin-auto flex"></div>
      </div>
      <div className="flex">
        &nbsp;{children}</div>
    </div>
  );
};

export default LineTitle;
